<template>
  <div style="width:100%;display:flex;flex-direction:row;">
    <div id="tree" ref="treeContainer" style="width: 75%; height: 100%" >
      <!--  horizontal是否横向   toolBar工具栏   collapsable是否可以展开收起节点     scalable架构图是否可缩放   node-draggable节点是否可拖拽    -->
      <!--  default-expand-level默认展开层级   clone-node-drag是否拷贝节点拖拽   on-node-click节点点击    @on-node-drag-end节点拖曳结束事件   -->
      <!--  only-one-node是否仅拖动当前节点，如果true，仅拖动当前节点，子节点自动添加到当前节点父节点，如果false，则当前节点及子节点一起拖动-->
      <!--  draggable 架构图是否可拖拽  before-drag-end 节点拖拽结束前事件-->
      <vue3-tree-org
          :data="treeData"
          ref="treeOrg"
          :horizontal="horizontal"
          :toolBar="true"
          :collapsable="collapsable"
          :label-style="style"
          :scalable="true"
          :node-draggable="false"
          :draggable="true"
          :only-one-node="false"
          :clone-node-drag="false"
          :default-expand-level="1"
          :before-drag-end="beforeDragEnd"
          @on-node-click="onNodeClick"
          @on-node-drag-end="onNodeDragEnd"
      >
        <template v-slot="{node}">
          <div
              class="tree-org-node__text node-label"
              style="cursor:pointer;"
              @dragover.prevent
              @drop="drop(node, $event)"
          >
            <div class="custom-content" style="font-size: 18px;">{{node.label}}</div>
            <div style="text-align: center;font-size: 14px">{{node.$$data.employee_cnt}} <span v-if="node.$$data.employee_cnt >= 0">人</span></div>
            <div class="custom-tree-node">
              <el-avatar class="custom-avatar" shape="square"
                         style="background-color: rgb(162,217,245)"
                         :src="(node.$$data.head_photo == null || node.$$data.head_photo.length===0) ? getPngSrc(node.$$data.head) : node.$$data.head_photo"></el-avatar>
              <div style="float: left;margin-left: 5px">
                <div style="font-size: 15px;font-weight: bold">{{node.$$data.head_name}}</div>
                <div style="font-size: 14px">{{node.$$data.head_position}}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 自定义展开按钮 -->
        <template v-slot:expand="{node}">
          <div @click.stop="handleExpand(node)">{{node.children.length}}</div>
        </template>
      </vue3-tree-org>
    </div>
    <div style="width: 25%;border-left: 1px solid lightgray">
      <div style="height: auto;" class="tree-org-node__text">
        <!--        右侧部门名称-->
        <div style="font-size: 15px;font-weight: bold;margin:10px 0 10px 10px">部门信息：
          <el-button id="addDept" size="small"  type="success" @click="addDept('addDept',currentDept)">添加部门</el-button>
          <el-button id="editDept" size="small"  type="primary" @click="editDept('editDept',currentDept)">编辑部门</el-button>
        </div>
        <div class="custom-content" style="font-size: 18px;margin: 10px auto 0;width: fit-content">{{ currentDept.label }}</div>
        <div style="text-align: center;font-size: 14px">{{ formattedEmployeeCount }}</div>
        <div class="custom-tree-node" style="justify-content: center">
          <el-avatar class="custom-avatar" shape="square" style="cursor:pointer;background-color: rgb(162,217,245)"
                     :src="(currentDept.head_photo == null || currentDept.head_photo.length===0) ? getPngSrc(currentDept.head) :currentDept.head_photo"></el-avatar>
          <div style="float: left;margin-left: 6px;white-space: nowrap;">
            <div style="font-size: 15px;font-weight: bold;">{{currentDept.head_name}}</div>
            <div style="font-size: 14px">{{currentDept.head_position}}</div>
          </div>
        </div>
        <div>
          <div style="font-size: 15px;font-weight: bold;margin:20px 0 0 10px">部门成员：
            <el-switch
                style="margin:0 0 0 100px"
                v-model="containChildDept"
                active-text="含子部门"
                @change="containChildDeptChange"/>
          </div>
        </div>
      </div>
      <div style="height: 70%;">
        <el-scrollbar>
          <div style="margin:0 10px 10px 10px;display: flex;justify-content: flex-start;flex-wrap: wrap">
            <div
                class="dept-tree-node"
                v-for="deptEmployee in currentDept.showDeptEmployee"
                :key="deptEmployee.id"
                draggable="true"
                @dragstart="dragStart(deptEmployee, $event)"
            >
              <el-avatar shape="square" class="custom-avatar" style="cursor:pointer;background-color: rgb(162,217,245)"
                         :src="(deptEmployee.photo == null || deptEmployee.photo.length===0) ? getPngSrc(deptEmployee)
                         :deptEmployee.photo" @error="errorHandler" >
              </el-avatar>
              <div style="float: left;margin-left: 5px">
                <div :style="{ color: deptEmployee.status === 'user_status_disable' ? 'red' : 'black' }" style="font-size: 14px;font-weight: bold">{{deptEmployee.employee_name}}</div>
                <div style="font-size: 13px">{{deptEmployee.user_position}}</div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 表单拖曳提示框 -->
    <el-dialog title="确认是否进行部门迁移" v-model="dialogVisible" width="30%" :show-close="false" :close-on-press-escape="false" center>
      <el-form :model="form">
        <el-form-item label-width="150px">
          <el-button type="primary" @click="confirmForm">确 定</el-button>
          <el-button type="warning" @click="cancelForm">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    拖曳部门角色权限选择框-->
    <el-dialog title="请进行部门迁移后的权限管理" v-model="dialogDepartmentRole" width="50%" :show-close="false"
               :close-on-press-escape="false" :close-on-click-modal="false" center>
      <el-form :model="formData" :rules="rules" ref="roleForm">
        <el-form-item  label="部门成员权限管理:" label-width="140px" required prop="departmentRole">
          <el-col :span="22">
            <el-select v-model="formData.departmentRole" @change="handleRoleChange" placeholder="请选择">
              <el-option label="保留原有权限" value="saveRole"></el-option>
              <el-option label="自定义权限" value="customRole"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showDepartmentRole" label="自定义权限:" label-width="140px" prop="customDepartmentRole" required>
          <el-col :span="22">
            <el-select v-model="formData.customDepartmentRole" no-data-text="当前无角色" filterable multiple clearable placeholder="请选择">
              <el-option v-for="item in roleList"  :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label-width="300px">
          <el-button id="btn1" type="primary" @click="saveFormRole">确 定</el-button>
          <el-button id="btn2" type="warning" @click="cancelFormRole">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    拖曳成员角色权限选择框-->
    <el-dialog title="请进行员工迁移后的权限管理" v-model="dialogUserRole" width="50%" :show-close="false"
               :close-on-press-escape="false"  center>
      <el-form :model="formData" :rules="rules" ref="roleForm">
        <el-form-item  label="员工权限管理:" label-width="140px" required prop="userRole">
          <el-col :span="22">
            <el-select v-model="formData.userRole" @change="handleRoleChanged" placeholder="请选择">
              <el-option label="保留原有部门权限" value="saveRole"></el-option>
              <el-option label="更新为现有部门权限" value="updateRole"></el-option>
              <el-option label="自定义权限" value="customRole"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showUserRole" label="自定义权限:" label-width="140px" prop="customUserRole" required>
          <el-col :span="22">
            <el-select v-model="formData.customUserRole" no-data-text="当前无角色" filterable multiple clearable placeholder="请选择">
              <el-option v-for="item in roleList"  :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label-width="300px">
          <el-button id="btn1" type="primary" @click="saveUserRole">确 定</el-button>
          <el-button id="btn2" type="warning" @click="cancelUserRole">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {Vue3TreeOrg} from "vue3-tree-org";

export default {
  name: "OrganizationStructureTest",
  components: {Vue3TreeOrg},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  setup(){
    return {
      errorHandler: () => {
        return true;
      }
    }
  },
  computed: {
    formattedEmployeeCount() {
      return this.currentDept.employee_cnt > 0 ? this.currentDept.employee_cnt + '人' : this.currentDept.employee_cnt;
    }
  },
  data() {
    return {
      treeData: {},
      defaultProps: {
        id: 'id',
        pid: 'parent_id',
        children: 'children',
        label: 'label',
        expanded: 'expanded',
      },
      containChildDept: false,
      horizontal: false,
      collapsable: true,
      dialogVisible: false, // 控制表单模态框的显示与隐藏
      formData: {
        departmentRole: 'saveRole',
        userRole: 'updateRole',
        customDepartmentRole: [],
        customUserRole: [],
        draggingNodeId: '',
        dropNodeId: '',
        userId: [],
        departmentId: ''
      },
      roleList: {},
      showDepartmentRole: false,
      showUserRole: false,
      rules: {
        departmentRole: [
          { required: true, message: '请选择部门成员权限管理', trigger: 'change' }
        ],
        customDepartmentRole: [
          { required: true, message: '请选择自定义权限', trigger: 'change' }
        ],
        userRole: [
          { required: true, message: '请选择成员权限管理', trigger: 'change' }
        ],
        customUserRole: [
          { required: true, message: '请选择自定义权限', trigger: 'change' }
        ]
      },
      isSameDepartment: false,
      dialogDepartmentRole: false,
      dialogUserRole: false,
      isConfirm: null,
      userName: '成员信息',
      form: {},
      style: {
        background: "#fff",
        color: "#5e6d82",
      },
      currentDept: {},
    };
  },

  async created() {
    await this.getDeptTreeData();
    await this.getRoleData();
  },
  mounted() {
    this.disableWheelZoom();
  },
  beforeUnmount() {
    this.enableWheelZoomCleanup();
  },
  methods: {

    // 展开按钮点击处理
    handleExpand(node) {
      node.expand = !node.expand; // 手动切换状态
    },

    //点击部门
    async onNodeClick(e,data){
      this.currentDept = data;
      this.containChildDept = false;
      if(this.currentDept){
        this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
      }
    },

    //刷新页面并且恢复刷新前的结构
    async refreshTree() {
      const currentDeptId = this.currentDept.id;
      // 保存树的展开状态
      const expandedKeys = this.$refs.treeOrg.getExpandKeys();
      // 重新获取数据并更新组件状态
      await this.getDeptTreeData();
      // 恢复树的展开状态
      this.$refs.treeOrg.setExpandKeys(expandedKeys);
      // 重新选中当前部门
      this.selectDepartment(currentDeptId);
    },

    //获取部门树
    async getDeptTreeData(){
      this.treeData = await this.$http('sysOrganizationService.getOrgStructureList')
      this.currentDept = this.treeData;
      this.containChildDept = false;
      if (this.currentDept){
        this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
      }
    },

    //点击部门成员头像
    avatarClick(item){
      let windowObj = {}
      windowObj.component = "sys/UserEdit";
      windowObj.name = "员工档案 - "+item.employee_name;
      windowObj.parentData = item;
      windowObj.height = 680 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 850 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },

    //点击部门负责人成员头像
    headAvatarClick(item){
      let windowObj = {}
      windowObj.component = "sys/UserEdit";
      windowObj.name = "员工档案 - "+item.head_name;
      windowObj.parentData = item;
      windowObj.height = 680 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 850 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },

    //添加部门
    addDept(buttonId,item){
      // 创建一个新的对象
      let busData = {
        button_id: buttonId,
        parent_name: item.name,
        parent_id: item.id,
      };

      let windowObj = {}
      windowObj.component = "sys/AddDept";
      windowObj.name = "添加部门";
      windowObj.parentData = busData;
      windowObj.height = 400 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 650 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }
      this.$store.dispatch('core/openWindow', windowObj)
    },

    //修改部门
    editDept(buttonId,item){
      let busData = {
        button_id: buttonId,
        name: item.name,
        id: item.id,
        type: item.type,
        role_ids: item.role_ids,
      };
      let windowObj = {}
      windowObj.component = "sys/AddDept";
      windowObj.name = "修改部门";
      windowObj.parentData = busData;
      windowObj.height = 400 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 650 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }
      this.$store.dispatch('core/openWindow', windowObj)
    },

    //添加职员
    addUser(buttonId,item){
      let busData = {
        button_id: buttonId,
        department_ids: item.id,
      };
      let windowObj = {}
      windowObj.component = "sys/AddUser";
      windowObj.name = "添加职员";
      windowObj.parentData = busData;
      windowObj.height = 680 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 800 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }
      this.$store.dispatch('core/openWindow', windowObj)
    },

    //导入职员
    importUser(buttonId,currentDept){
      let busData = {
        button_id: buttonId,
        department_ids: currentDept.id,
      };
      let windowObj = {}
      windowObj.component = "sys/ImportUser";
      windowObj.name = "导入职员";
      windowObj.parentData = busData;
      windowObj.height = 450 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 700 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.refreshTree();
        },
      }
      this.$store.dispatch('core/openWindow', windowObj)
    },


    //是否显示子部门成员
    containChildDeptChange(status){
      if(this.currentDept){
        if(status){
          this.currentDept.showDeptEmployee = this.currentDept.deptEmployee;
        }else {
          this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
        }
      }
    },

    //部门拖曳过程
    async beforeDragEnd(node, targetNode) {
      console.log('beforeDragEnd:', node, 'Target node:', targetNode);
      return new Promise(async (resolve, reject) => {
        //判断目标部门下是否有相同名称部门
        let params = {
          targetNodeId: targetNode.id,
          NodeId: node.id,
          nodeLabel: node.label,
        }
        console.log('params', params)

        if (params.targetNodeId && params.NodeId && params.nodeLabel) {
          if (targetNode.id === node.id){
            this.$message({
              showClose: true,
              message: '不能拖曳到自己',
              type: 'warning'
            });
            reject(new Error('拖拽失败'));
            return;
          }
          try {
            this.isSameDepartment = await this.$http('sysOrganizationService.isSameDepartment', params);
            console.log('isSameDepartment', this.isSameDepartment)
            if (this.isSameDepartment) {
              this.$message({
                showClose: true,
                message: '目标部门下已存在或历史存在相同名称部门，不可拖曳！',
                type: 'warning'
              });
              reject(new Error('拖拽失败'));
              return;
            }
          } catch (error) {
            console.error('检查部门名称时出错:', error);
            reject(new Error('拖拽失败'));
            return;
          }
        } else {
          reject(new Error('拖拽失败'));
          return;
        }

        // 处理表单结果
        this.openForm().then(result => {
          if (result) {
            resolve('拖拽成功');
            this.$message({
              showClose: true,
              message: '拖拽成功',
              type: 'success'
            });
          } else {
            reject(new Error('拖拽取消'));
            this.$message({
              showClose: true,
              message: '拖拽取消',
              type: 'warning'
            });
          }
        });
      });
    },

    //部门拖曳确认表单
    openForm() {
      this.dialogVisible = true;
      return new Promise((resolve) => {
        this.isConfirm = resolve;
      });
    },

    //部门表单拖曳提示框确认按钮
    confirmForm() {
      this.isConfirm(true);
      this.dialogVisible = false;
    },

    //部门表单拖曳提示框取消按钮
    cancelForm() {
      this.isConfirm(false);
      this.dialogVisible = false;
    },

    //部门拖曳结束事件
    async onNodeDragEnd(draggingNode, dropNode, dropType) {
      console.log('draggingNode:', draggingNode, 'dropNode:', dropNode, dropType);
      dropNode.expanded = true;
      this.formData.draggingNodeId = draggingNode.id;
      this.formData.dropNodeId = dropNode.id;
      this.dialogDepartmentRole = true;
    },

    //部门角色选择框切换
    handleRoleChange(value) {
      this.showDepartmentRole = value === 'customRole';
      if (!this.showDepartmentRole) {
        this.formData.customDepartmentRole = '';
      }
    },

    //选择自定义权限显示权限下拉框
    handleRoleChanged(value) {
      this.showUserRole = value === 'customRole';
      if (!this.showUserRole) {
        this.formData.customUserRole = '';
      }
    },

    //部门角色选择框取消
    async cancelFormRole() {
      this.$refs.roleForm.resetFields();
      this.dialogDepartmentRole = false;
      await this.$http('sysOrganizationService.transferDepartmentUser',this.formData);
      this.formData.dropNode = {};
      this.formData.draggingNode = {};
      this.$fn.reloadTreeData();
    },

    //部门角色选择框保存
    async saveFormRole() {
      this.$refs.roleForm.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行保存操作
          this.dialogDepartmentRole = false;
          await this.$http('sysOrganizationService.transferDepartmentUser',this.formData);
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success'
          });
          this.formData.dropNode = {};
          this.formData.draggingNode = {};
          this.$fn.reloadTreeData();
        } else {
          return false;
        }
      });
    },

    //成员点击事件
    dragStart(employee, event) {
      this.draggedEmployee = employee;
      event.dataTransfer.setData('text/plain', JSON.stringify(employee));
    },

    //成员拖曳事件
    drop(node, event) {
      event.preventDefault();
      const draggedEmployee = JSON.parse(event.dataTransfer.getData('text/plain'));
      if (draggedEmployee && node) {
        //不可拖曳到自己部门下
        if (draggedEmployee.department_ids.includes(node.id)) {
          this.$message({
            showClose: true,
            message: '不能拖曳到自己所在部门',
            type: 'warning'
          });
          return;
        }
        this.formData.userId = draggedEmployee.id;
        this.formData.departmentId = node.id;
        this.dialogUserRole = true;
      }
    },

    //保存用户权限
    async saveUserRole() {
      try {
        // 发送请求
        await this.$http('sysOrganizationService.transferUser', this.formData);
        // 显示成功消息
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success'
        });
        // 清空表单数据
        this.formData.userId = '';
        this.formData.departmentId = '';
        // 关闭对话框
        this.dialogUserRole = false;
        await this.refreshTree();
      } catch (error) {
        // 处理错误
        this.$message({
          showClose: true,
          message: '操作失败，请重试',
          type: 'error'
        });
      }
    },

    cancelUserRole() {
      this.dialogUserRole = false;
    },

    // 重新选中当前部门
    selectDepartment(departmentId) {
      const traverse = (nodes) => {
        for (const node of nodes) {
          if (node.id === departmentId) {
            this.currentDept = node;
            this.containChildDept = false;
            this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
            return;
          }
          if (node.children) {
            traverse(node.children);
          }
        }
      };
      traverse(this.treeData.children);
    },

    //获取所有权限列表
    async getRoleData(){
      this.roleList = await this.$http('sysOrganizationService.getRoleList');
    },

    getPngSrc(deptEmployee){
      if(!deptEmployee){
        return 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png';
      }
      let sex = deptEmployee.gender;
      if(!sex){
        return 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png';
      }
      if(sex === '男'){
        return '/icon/male.png';
      }else {
        return '/icon/female.png';
      }
    },
    disableWheelZoom() {
      this.$nextTick(() => {
        const container = this.$refs.treeContainer;

        if (!container) return;

        this._wheelHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
        };

        container.addEventListener('wheel', this._wheelHandler, {
          passive: false,
          capture: true,
        });
      });
    },

    enableWheelZoomCleanup() {
      const el = this.$refs.treeContainer;

      if (el && this._wheelHandler) {
        el.removeEventListener('wheel', this._wheelHandler);
      }
    },

  },

};
</script>


<style scoped lang="less">

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding-right: 8px;
  white-space: nowrap;
}

.custom-avatar {
  width: 35px; /* 设置宽度为二寸照片宽度 */
  height: 49px; /* 设置高度为二寸照片高度的1.5倍 */
  object-fit: cover; /* 确保图片覆盖整个容器，保持比例 */
  border-radius: 4px; /* 如果需要圆角效果 */
}

.node-label {
  margin-left: 8px;
}

.tree-org-node__text {
  text-align: left;
  font-size: 14px;
}

.custom-content {
    text-align: center;
    color:#fff;
    background-color: #108ffe;
    padding: 0 2px 0 2px;
    white-space: nowrap;
}

.dept-tree-node {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  min-width:50%;
  margin-top: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

::v-deep .custom-menu {
  background-color: black;
  border: 1px solid #ccc;
  padding: 5px;
  color: black;
  font-size: 14px;
  position: absolute;
  z-index: 1000;
}
</style>